/**
 * Generated runtime TestId mirror for frontend/src/pages/TypeDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TypeDetailTestIds = {
  btnAddValue: "btn-add-value",
  btnCancelDelete: "btn-cancel-delete",
  btnCloseView: "btn-close-view",
  btnConfirmDelete: "btn-confirm-delete",
  btnEditTranslations: "btn-edit-translations",
  btnSetInactive: "btn-set-inactive",
  colDescription: "col-description",
  colDescriptionEdit: "col-description-edit",
  colLabel: "col-label",
  colLabelEdit: "col-label-edit",
  colLanguage: "col-language",
  colLanguageEdit: "col-language-edit",
  typeDetailPage: "type-detail-page",
  activeCell: (value_code: string) => `active-cell-${value_code}`,
  activeCellPrefix: () => "active-cell-" as TestIdPrefix,
  btnActions: (value_code: string) => `btn-actions-${value_code}`,
  btnActionsPrefix: () => "btn-actions-" as TestIdPrefix,
  btnToggleActive: (value_code: string) => `btn-toggle-active-${value_code}`,
  btnToggleActivePrefix: () => "btn-toggle-active-" as TestIdPrefix
} as const;
